import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { media } from "style-utils";
import { merge, isEmpty } from 'lodash';
import { NitroContentNotAvailable } from "nitro-components";


import numeral from 'numeral';

import {
  NitroText,
  NitroFormatter,
} from "nitro-components";

const ChartContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const SummaryPanel = styled.div`
  & > span {
    display: block;
    text-align: center;
  };
  padding: 20px 0;
  border-bottom: solid 1px #ddd;
  flex: 1 0 50%;
`

const SummaryBlock = styled.div`
  display: flex;
`;

const SummaryItem = styled.div`
  padding: 0 10px;

  &.valign-middle {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &.talign-center {
    text-align: center;
  }

  &.icon-box {
    width: 50px;
  }

  &.display-info {
    text-align: right;
    flex: 1;
    & > span {
      font-weight: bolder;
      white-space: nowrap;
    }
  }

  &.trend-holder {
    margin-left: auto;
    padding-right: 15px;
    padding-left: 0;
    width: 30px;
  }
`;

const IconBox = styled.div`
  display: block;
  font-size: 28px;
  text-shadow: 2px 2px 10px #999;
`;

const IconTrend = styled.div`
  display: block;
  font-size: 16px;
`


const TrendDisplay = ({prevNumber, currNumber}) =>{
  let perc = 0;
  let isUp = false;

  if(prevNumber && prevNumber > 0 && currNumber && currNumber > 0) {
    const delta = currNumber - prevNumber;
    isUp = (delta > 0)? true: false;
    perc = (delta === 0 )? 0 : Math.ceil( Math.abs(delta) / prevNumber * 100);
  } else {
    perc = NaN;
  }

  let color = '#707070';
  let iconClass = 'fas fa-ellipsis-h';
  let percDisplay = 'No data';

  if (isNaN(perc) || perc === 0) {
    return null;
  }

  percDisplay = perc + '%';
  if(perc === 0) {

  } else if ( isUp ) {
    color = 'green';
    iconClass = 'fas fa-angle-up';
  } else {
    color = 'red';
    iconClass = 'fas fa-angle-down';
  }


  return (
    <div style={{ color }}>
      <IconTrend className={iconClass} />
      <NitroText size={11} >{percDisplay}</NitroText>
    </div>
  )
}

const SummaryBox = ({data, config, metadata}) => {

  const metaDefault = {
    icon: 'fas fa-car',
    chartDescription: '',
    valueType: 'shortinteger'
  }

  const metainfo = merge({}, metaDefault, metadata)

  const dataCount =data.filter(ea => typeof(ea) === 'number').length;

  return (
    <SummaryPanel>
      <SummaryBlock>
        <SummaryItem className="valign-middle icon-box">
          <IconBox className={ metainfo.icon } />
        </SummaryItem>

        <SummaryItem className="talign-center valign-middle">
          <NitroText variant="base2" size={12}>{metainfo.chartDescription || ''}</NitroText>
        </SummaryItem>

        <SummaryItem className="valign-middle display-info">
          <NitroFormatter type={metainfo.valueType} variant="secondary" size={20} data={config.displayNumber} />
        </SummaryItem>

      </SummaryBlock>
  </SummaryPanel>
  )
}

class ChartSummaryDisplay extends Component {

  render() {
    const {data, metadata} = this.props;
    const parsedmeta = JSON.parse(metadata.metadata);

    if(isEmpty(data.summaryData)) {
      return <NitroContentNotAvailable />
    }

    return (
      <ChartContainer>
        {
          parsedmeta.config.map((ea) => {
            if(ea && data.summaryData[ea.category]) {
              return <SummaryBox
                {...data.summaryData[ea.category]}
                metadata={ea}
                key={ea.category}/>
            }
          })
        }
      </ChartContainer>
    )
  }
}

ChartSummaryDisplay.propTypes = {
  data: PropTypes.object.isRequired,
  metadata: PropTypes.object.isRequired
}

export default ChartSummaryDisplay;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartSummaryDisplay.js